export interface Dimension {
  hoeheBez: string | null;
  hoehe: number;
  breiteBez: string | null;
  breite: number;
  tiefeBez: string | null;
  tiefe: number;
}
